import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { User } from "../../_models/user";
import { ApiIntegration } from '../../_services/api.integration';

@Component({
  selector: 'app-gati-manage',
  templateUrl: './gati-manage.component.html',
  styleUrls: ['./gati-manage.component.scss'],
})
export class GatiManageComponent implements OnInit {

  carrierNameError: string;
  customerCodeError: string;
  carrierId: any;
  gatiData: any = {};

  constructor(private api: ApiIntegration, private alertService: AlertService, private g: Globals, private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute) {

    if (this.carrierId) {
      this.api.getCarrierInfoById(this.user.accountOwnerId, this.carrierId, this.user.organizationId).subscribe((data: any) => {
        this.gatiData = data;
      }, err => {
        this.alertService.error('Error', err);
      });
    }

  }

  carrierNameBlur() {
    this.carrierNameError = "";
    if (!this.gatiData.connectionName) {
      this.carrierNameError = 'Please enter carrier name';
    }
  }

  customerCodeBlur() {
    this.customerCodeError = "";
    if (!this.gatiData.customerCode) {
      this.customerCodeError = 'Please enter customer code';
    }
  }


  ngOnInit() { }

  verify() {

    this.g.loaderDisplay = "display";
    this.carrierNameError = "";
    this.customerCodeError = "";

    if (!this.gatiData.connectionName) {
      this.carrierNameError = 'Please enter carrier name';
    }
    if (!this.gatiData.customerCode) {
      this.customerCodeError = 'Please enter customer code';
    }
    if (this.carrierNameError != "" || this.customerCodeError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    // api body
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateCarrierCredentials', {

      "customerCode": this.gatiData.customerCode,
      "accountOwnerId": this.gatiData.accountOwnerId,
      "carrierCode": this.gatiData.carrierCode,
      "connectionName": this.gatiData.connectionName,
      "organizationId": this.gatiData.organizationId,
      "carrierId": this.gatiData.carrierId

    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Gati', 'Create Successfully');
          this.router.navigate(['/admin/customerCarriers']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        })
  }

}

